import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { TagsListProps } from '@new/domains/bookings/stores/_types'

import { FiltersSharedProps } from './Filters.types'

interface TagsFilterProps extends FiltersSharedProps {
  title: string
  tagsList: TagsListProps
  initialValue?: string[]
  onChange: (value?: string[]) => void
  isLoadingOptions?: boolean
}

const _TagsFilter: FC<TagsFilterProps> = ({
  initialValue,
  tagsList,
  title,
  onChange,
  isLoadingOptions,
  ...props
}) => {
  const tagsOptions =
    tagsList?.map(({ name, id: { id, tagLevel } }) => ({
      label: name,
      value: `${tagLevel}-${id}`,
    })) || []

  return (
    <CheckboxBasedFilter
      title={title}
      options={tagsOptions}
      initialValue={initialValue}
      onChange={onChange}
      isLoadingOptions={isLoadingOptions}
      {...props}
    />
  )
}

export const TagsFilter = observer(_TagsFilter)
